import apiClient from "utilities/apiClient";

/**
 * Typed wrappers for the batch-2 document endpoints. Keeps query-string
 * construction out of the components.
 */

const buildFilterParams = (pageOptions = {}) => {
  const params = {};
  if (pageOptions.search) params.search = pageOptions.search;
  if (pageOptions.updation_status)
    params.updation_status = pageOptions.updation_status;
  if (pageOptions.extraction_status && pageOptions.extraction_status.length)
    params.extraction_status = pageOptions.extraction_status.join(",");
  if (pageOptions.date_range_start)
    params.date_range_start = pageOptions.date_range_start;
  if (pageOptions.date_range_end)
    params.date_range_end = pageOptions.date_range_end;
  return params;
};

const documentService = {
  getCounts: (pageOptions) =>
    apiClient.get("/document/counts", buildFilterParams(pageOptions)),

  archive: (documentId) => apiClient.patch(`/document/archive/${documentId}`),

  reprocess: (documentId) =>
    apiClient.post(`/document/reprocess/${documentId}`),

  uploadInvoice: (payload) => apiClient.post("/extraction/manual", payload),

  lookup: (field) => apiClient.get("/document/lookup", { field }),

  checkDuplicate: ({ reference, policyholder, excludeId }) =>
    apiClient.get("/document/duplicate", {
      reference,
      policyholder,
      excludeId,
    }),

  addNote: (documentId, { notes, author_id, author_name }) =>
    apiClient.post(`/document/note/${documentId}`, {
      notes,
      author_id,
      author_name,
    }),
};

export default documentService;
